import { Configuration as UtilitiesConfiguration } from 'cfg-utilities-fe/client/runtime';
import { Configuration } from '@/services/generated/client/runtime';
import { snakeCase } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export function getApiConfiguration(): Configuration {
  return new Configuration({
    basePath: process.env.VUE_APP_API_LOCATION,
  });
}

export function getUtilitiesConfiguration(): UtilitiesConfiguration {
  return new UtilitiesConfiguration({
    basePath: process.env.VUE_APP_DOCUMENTS_LOCATION,
  });
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function toSnackCase<T>(obj: T): {} {
  const n = {};

  Object.keys(obj).forEach((k) => {
    n[snakeCase(k)] = obj[k];
  });
  return n;
}
